import { HeroSection } from "../components/site/HeroSection";
import { EditorialMarquee } from "../components/site/EditorialMarquee";
import { ManifestoChapters } from "../components/site/ManifestoChapters";
import { MarketsOverview } from "../components/site/MarketsOverview";
import { RegulatorySection } from "../components/site/RegulatorySection";
import { ItalySection } from "../components/site/ItalySection";
import { ServicesSection } from "../components/site/ServicesSection";
import { HeritageSection } from "../components/site/HeritageSection";
import { ContactSection } from "../components/site/ContactSection";

export default function Home() {
  return (
    <main data-testid="home-page">
      <HeroSection />
      <EditorialMarquee />
      <ManifestoChapters />
      <MarketsOverview />
      <RegulatorySection />
      <ItalySection />
      <ServicesSection />
      <HeritageSection />
      <ContactSection />
    </main>
  );
}
